import { useState, useEffect } from 'react';

/**
 * 特定の階層においてタグ追加ボタンが無効かどうかを判断するカスタムフック。
 *
 * @param {number} depth - 現在考慮中の階層。0 はタグセットの階層、1 以上はタグの階層を示す。
 * @param {Array} selectedTagIds - 各階層において選択されたタグのIDの配列。
 * @param {string} selectedTagSetId - 選択されたタグセットのID。
 * @param {boolean} isCompanyAdminUser - ユーザーが企業管理者かどうかの真偽値。
 * @returns {boolean} 追加ボタンが無効である場合は true、そうでない場合は false。
 */
const useIsAddDisabled = (
  depth,
  selectedTagIds,
  selectedTagSetId,
  isCompanyAdminUser,
) => {
  const [isAddDisabled, setIsAddDisabled] = useState(true);

  useEffect(() => {
    if (depth === 0) {
      setIsAddDisabled(false);
    } else if (depth === 1 && selectedTagSetId) {
      setIsAddDisabled(false);
    } else if (depth >= 2 && selectedTagIds[depth - 2]) {
      setIsAddDisabled(false);
    } else {
      setIsAddDisabled(true);
    }
    if (!isCompanyAdminUser) {
      setIsAddDisabled(true);
    }
  }, [depth, isCompanyAdminUser, selectedTagSetId, selectedTagIds]);

  return isAddDisabled;
};

export default useIsAddDisabled;
